module.exports = __webpack_public_path__ + "img/Charlotte Meadows.56ecbf59.jpg";